/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import AnnoucementModel from "./AnnoucementModel";
import { preventAnchorTags } from "../../utils/commonFunctions";

function MobileAnnouncementBar({ activeAnnouncement, handlecloseAnnouncement }) {
  const [show, setShow] = useState(false);
  const handleClick = (e) => {
    e?.stopPropagation();
    if (activeAnnouncement?.link) {
      window.open(activeAnnouncement?.link?.startsWith("www.") ? `https://${activeAnnouncement?.link}` : activeAnnouncement?.link, "_blank");
    }
  };

  useEffect(() => {
    preventAnchorTags("announcement-outer");
  }, []);

  const handleOpenAnnouncement = () => {
    setShow(true);
  };
  return (
    <div
      className="announcement-bar ps-2 py-2 pe-5 d-flex d-lg-none align-items-center justify-content-center cursor-pointer"
      style={{ background: activeAnnouncement.color }}
      onClick={handleOpenAnnouncement}
    >
      <i className="fa-solid fa-xmark position-absolute top-50 end-0 translate-middle-y p-3 cursor-pointer" onClick={handlecloseAnnouncement} />
      <div
        className="text-lg fw-bold me-3 announcement-inner overflow-hidden announcement-outer"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(activeAnnouncement?.announcement?.replaceAll("</p><p>", " ").replace(/<br>/g, "")),
        }}
      />
      {show && (
        <AnnoucementModel
          activeAnnouncement={activeAnnouncement}
          isOpen={show}
          toggle={() => {
            setShow(!show);
          }}
          onClosed={() => setShow(false)}
          onClick={handleClick}
        />
      )}
    </div>
  );
}

export default MobileAnnouncementBar;
